// extracted by mini-css-extract-plugin
export default {"container":"MyProjects_container__QfcbY","info":"MyProjects_info__0QFUn"};